import { render, staticRenderFns } from "./allertModal.vue?vue&type=template&id=5de13718&scoped=true"
import script from "./allertModal.vue?vue&type=script&lang=js"
export * from "./allertModal.vue?vue&type=script&lang=js"
import style0 from "./allertModal.vue?vue&type=style&index=0&id=5de13718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de13718",
  null
  
)

export default component.exports